export default "__VITE_ASSET__nt2MfZKg__"